export default [
  {
    name: "black_girl_hoverboard_model",
    type: "gltfModel",
    path: "models/black_girl_hoverboard_animated_parented.glb",
  },
];
